import React, { useEffect } from 'react'
import { useGeneralParams } from '../../../../../../hooks/useDataPaginate'
import { CreateValues, DeleteValues } from '../../../../../../FormSchemes/AlmacenCierreScheme'
import { MinimalActionButton } from '../../../../../../components/form/minimalActionButton'
import { useSelector } from 'react-redux'
import { formatDateWithTime } from '../../../../../../utils/dateFormat'
import { DefaultParamsForRecall } from '../../../../../../utils/defaulStates'
import { Callers } from '../../../../../../hooks/Callers'

export const ListAlmacenCierreTable = ({
    reload,
    setReload,
    dataCard
}) => {
    const {
        dispatch,
        params,
        data, setData,
        paginate, setPaginate,
        selectedDay, setSelectedDay,
        selecteds, setSelecteds,
        selectAllChecked, setSelectAllChecked,
        isChecked, setIsChecked,
        stateData, setStateData,
        createModal, setCreateModal,
        deleteModal, setDeleteModal,
        currentData, setCurrentData,
        // imports
        requestAuthPaginate,
        TableContainer,
        Paginator,
        // formatFilters,
        Searcher,
        // FilterSelect,
        // RangeDate,
        Actions,
        TableSection,
        ActionSection,
        Section,
        ModalForm,
        UpdateValuesModal,
        redirect
    } = useGeneralParams()
    const reloadMinorTable = useSelector(state => state.login.reloadMinorTable)

    const getDataPaginate = async () => {
        await requestAuthPaginate({
            method: 'get',
            url: `/almacenProducto/${params.almacen_producto_id}/cierres/pag`,
            data: null,
            queries: paginate,
            setData: setData,
            setStateData: setStateData,
            setQueries: setPaginate,
            dispatch: dispatch,
            aditionalParams: { filterBy: 'producto' }
        })
    }
    useEffect(() => {
        getDataPaginate();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), params.almacen_producto_id, reloadMinorTable]);

    useEffect(() => {
        setSelectAllChecked(false)
        setIsChecked(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), params.almacen_producto_id]);


    const reloadTable = () => {
        Callers(dispatch)
    }

    return (
        <Section>
            <ActionSection>
                <Actions
                    buttons={[
                        {
                            icon: 'shop-lock',
                            label: 'Crear cierre',
                            action: () => setCreateModal(true)
                        },
                    ]}
                />
                <Searcher
                    paginate={paginate}
                    setPaginate={setPaginate}
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    options={[
                        {
                            label: 'Producto',
                            value: 'producto'
                        },
                    ]}
                    reloadTable={reloadTable}
                />
                <div className='flex gap-2 flex-wrap'>
                    {/* <RangeDate
                        selectedDay={selectedDay}
                        setSelectedDay={setSelectedDay}
                        paginate={paginate}
                        setPaginate={setPaginate}
                    />
                    <FilterSelect
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                        name='estado'
                        options={[
                            {
                                label: 'Estado',
                                value: ''
                            },
                            {
                                label: 'Activo',
                                value: 'activo'
                            },
                            {
                                label: 'Inactivo',
                                value: 'inactivo'
                            }
                        ]}
                    /> */}
                    <MinimalActionButton
                        icon='repeat'
                        label=''
                        action={reloadTable}
                    />
                </div>
            </ActionSection>
            <TableSection
                stateData={stateData}
                paginator={Paginator}
                data={data}
            >
                <TableContainer
                    headers={[
                        {
                            label: 'Nombre',
                            columns: ['nombre']
                        },
                        {
                            label: 'Cantidad inicial',
                            columns: ['cantidad_inicial'],
                            numberValue: true
                        },
                        {
                            label: 'Cantidad final',
                            columns: ['cantidad_final'],
                            numberValue: true
                        },
                        {
                            label: 'Cantidad ingreso',
                            columns: ['cantidad_total_ingreso'],
                            numberValue: true
                        },
                        {
                            label: 'Cantidad egreso',
                            columns: ['cantidad_total_egreso'],
                            numberValue: true
                        },
                        {
                            label: 'Fecha de inicio',
                            columns: ['fecha_inicio'],
                            transform: true,
                            func: formatDateWithTime
                        },
                        {
                            label: 'Fecha de fin',
                            columns: ['fecha_fin'],
                            transform: true,
                            func: formatDateWithTime
                        },
                        {
                            label: 'Acciones',
                            actions: [
                                // {
                                //     type: 'edit',
                                //     icon: 'fa-edit',
                                //     // action: (data) => UpdateValuesModal(data, setCurrentData, setUpdateModal),
                                // },
                                {
                                    type: 'yellow',
                                    icon: 'fa-share-from-square',
                                    action: (data) => redirect(`historial/${data.id}`),
                                    reference: 'id',
                                    redirect: true
                                },
                                {
                                    type: 'delete',
                                    icon: 'fa-trash',
                                    action: (data) => UpdateValuesModal(data, setCurrentData, setDeleteModal),
                                    reference: 'id',
                                    tooltipText: 'eliminar'
                                },
                            ],
                            // stickyR: true
                        },
                    ]}
                    data={data.data}
                    checkList={true}
                    selecteds={selecteds}
                    setSelecteds={setSelecteds}
                    selectAllChecked={selectAllChecked}
                    setSelectAllChecked={setSelectAllChecked}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                    stateData={stateData}
                />
            </TableSection>
            {
                deleteModal &&
                <ModalForm
                    setModal={setDeleteModal}
                    label='Eliminar cierre del almacén'
                    dataValues={DeleteValues(currentData)}
                    urlApi={`/almacenCierre/${currentData.id}`}
                    method={'delete'}
                    call={reloadTable}
                    buttonLabel='Eliminar'
                />
            }
            {
                createModal &&
                <ModalForm
                    setModal={setCreateModal}
                    label='Crear cierre'
                    dataValues={CreateValues(params?.almacen_producto_id)}
                    urlApi={`/almacenCierre`}
                    method={'post'}
                    call={reloadTable}
                    buttonLabel='Crear cierre'
                />
            }
        </Section>
    )
}